(() => {
  'use strict';

  const root =
    document.querySelector(
      '[data-pnadm-dashboard]'
    );


  if (!root) {
    return;
  }


  const links =
    [
      ...root.querySelectorAll(
        '[data-pnadm-nav]'
      )
    ];


  const views =
    [
      ...root.querySelectorAll(
        '[data-pnadm-view]'
      )
    ];


  const operations = new Set([
    'pricing',
    'users',
    'colleges',
    'bookings',
    'payments',
    'events',
    'communities',
    'reviews',
    'analytics',
    'logs'
  ]);


  function visibleViewFor(
    key
  ) {

    if (
      operations.has(
        key
      )
    ) {
      return 'operations';
    }


    return key;

  }


  function activate(
    key,
    updateHash = true
  ) {

    const viewKey =
      visibleViewFor(
        key
      );


    views.forEach(view => {

      view.hidden =
        view.dataset.pnadmView !==
        viewKey;

    });


    links.forEach(link => {

      link.classList.toggle(
        'is-active',
        link.dataset.pnadmNav ===
        key
      );

    });


    if (
      operations.has(
        key
      )
    ) {

      root.dataset
        .pnadmActiveOperation =
        key === 'pricing' ? 'payments' : key;


      document.dispatchEvent(
        new CustomEvent(
          'peernest:admin-operation-view',
          {
            detail:{
              key: key === 'pricing' ? 'payments' : key
            }
          }
        )
      );

      document.dispatchEvent(new CustomEvent('peernest:admin-finance-target', {
        detail: {mode: key === 'pricing' ? 'pricing' : 'transactions'}
      }));

    }


    if (
      updateHash
    ) {

      history.replaceState(
        {},
        '',
        `#${key}`
      );

    }


    if (updateHash) {
      window.scrollTo({
        top:
          root.getBoundingClientRect().top +
          window.scrollY -
          115,

        behavior:
          'smooth'
      });
    }

  }


  links.forEach(link => {

    link.addEventListener(
      'click',
      event => {

        event.preventDefault();


        activate(
          link.dataset.pnadmNav
        );

      }
    );

  });


  const initial =
    window.location.hash
      .replace(
        '#',
        ''
      );


  const valid =
    links.some(
      link =>
        link.dataset.pnadmNav ===
        initial
    );


  activate(
    valid
      ? initial
      : 'overview',
    false
  );

})();
